import { Modal } from "bootstrap";
import "../../../assets/src/eos/js/main";
import "select2/dist/css/select2.css";
import "../../../assets/src/eos/less/ui-components/bootstrap/modal.scss";
import "../../../assets/src/eos/less/ui-components/forms.less";
import "../../../assets/src/eos/less/ui-components/select2-reset.less";
import "../../components/bootstrap/fix-modals.scss";
import "../../../assets/src/eos/less/ui-components/footer.less";

import setContactModalHandlers from "../../../assets/src/eos/js/modals/setContactModalHandlers";
import "../../../assets/src/eos/less/ui-components/bootstrap/modal-progress";

import "./page-whats-new.scss";

(function () {
  let arr = [];
  $('button[data-bs-toggle="modal"]').each(function () {
    arr.push($(this).data("bs-target"));
  });
  [...new Set(arr)].forEach((element) => setContactModalHandlers(element));
})();

$(document).ready(function () {
  let currentPage = $("#whats-new-loadmore").data("current-page");
  let maxPages = $("#whats-new-loadmore").data("max-pages");
  let $tagContainer = $(".tag-container");
  let $tagWrapper = $(".tag-list");
  let $prevBtn = $(".scroll-buttons .left");
  let $nextBtn = $(".scroll-buttons .right");

  let tagWrapperWidth = $tagWrapper.outerWidth();
  let tagContainerWidth = $tagContainer.outerWidth();

  let tagContainerLeft = $tagContainer.offset().left;
  let tagWrapperLeft = $tagWrapper.position().left;

  let dataShowLabel = $(".container").data("show-label");
  let dataHideLabel = $(".container").data("hide-label");

  let maxScroll = tagWrapperWidth - tagContainerWidth;
  let scrollAmount = 0;

  function addReadMoreButton($card) {
    let contentWrap = $card.find(".content-wrap");
    let contentWrapHeight = contentWrap.height();
    let contentHeight = $card.find(".content").height();
    let btnReadMore = $card.find(".read-more");

    if (contentHeight > contentWrapHeight) {
      console.log(dataShowLabel);
      btnReadMore.css("display", "block").text(dataShowLabel);
    }

    btnReadMore.off("click").on("click", function () {
      contentWrap.toggleClass("open");

      if (contentWrap.hasClass("open")) {
        $(this).text(dataHideLabel);
      } else {
        $(this).text(dataShowLabel);
      }
    });
  }

  $(".card").each(function () {
    let $card = $(this);
    addReadMoreButton($card);
  });

  if (!("ontouchstart" in window)) {
    $(".flags").on("mouseover", function () {
      $(this).addClass("open");
    });

    $(".flags").on("mouseout", function () {
      $(this).removeClass("open");
    });
  }

  $(".flags .main-flag>span").on("click", function () {
    $(".flags").toggleClass("open");
  });

  $(document).on("click", function (event) {
    if (
      !$(event.target).is(".flags .main-flag>span") &&
      !$(event.target).is(".flag-list")
    ) {
      $(".flags").removeClass("open");
    }
  });

  function checkBtns() {
    if (tagContainerWidth > tagWrapperWidth) {
      $prevBtn.hide();
      $nextBtn.hide();

      $tagContainer.css("justify-content", "center");
    } else {
      $tagContainer.css("justify-content", "flex-start");

      if (scrollAmount == 0) {
        $prevBtn.hide();
      } else {
        $prevBtn.show();
      }

      if (scrollAmount == maxScroll) {
        $nextBtn.hide();
      } else {
        $nextBtn.show();
      }
    }
  }

  checkBtns();

  $(window).resize(function () {
    tagWrapperWidth = $tagWrapper.outerWidth();
    tagContainerWidth = $tagContainer.outerWidth();
    tagContainerLeft = $tagContainer.offset().left;
    tagWrapperLeft = $tagWrapper.position().left;
    maxScroll = tagWrapperWidth - tagContainerWidth;
    checkBtns();
  });

  $prevBtn.on("click", function () {
    scrollAmount -= tagContainerWidth;
    if (scrollAmount < 0) {
      scrollAmount = 0;
    }
    $tagWrapper.animate({ left: -scrollAmount });
    checkBtns();
  });

  $nextBtn.on("click", function () {
    scrollAmount += tagContainerWidth;
    if (scrollAmount > maxScroll) {
      scrollAmount = maxScroll;
    }
    $tagWrapper.animate({ left: -scrollAmount });
    checkBtns();
  });

  $(".tag").on("click", function (e) {
    e.preventDefault();

    let termId = $(this).data("term-id");
    let ajaxUrl = $(this).data("ajax-url");
    let truePosts = $("#whats-new-loadmore").data("true-posts");
    let postPerLoad = $("#whats-new-loadmore").data("post-per-page");

    currentPage = 0;

    $(".tag").removeClass("active");
    $(this).addClass("active");
    $.ajax({
      url: ajaxUrl,
      type: "POST",
      dataType: "json",
      data: {
        action: "whats_new_ajax",
        termId: termId,
        query: truePosts,
        page: currentPage,
        "post-per-load": postPerLoad,
      },
      success: function (data) {
        if (data) {
          $(".col-md-8.offset-md-2.col-xl-6.offset-xl-3").html(data.html);
          maxPages = data.max_num;
          if (data.max_num === 1) {
            $("#whats-new-loadmore")
              .attr("disabled", true)
              .css("display", "none");
          } else {
            $("#whats-new-loadmore")
              .attr("disabled", false)
              .css("display", "block");
          }
        }

        $(".card").each(function () {
          let $card = $(this);
          addReadMoreButton($card);
        });
      },
    });
  });

  $("#whats-new-loadmore").on("click", function () {
    let loadMoreButton = $(this);
    let ajaxUrl = $(this).data("ajax-url");
    let truePosts = $(this).data("true-posts");
    let postPerLoad = $(this).data("post-per-page");
    let termId = $(".tag.active").data("term-id");

    loadMoreButton.attr("disabled", true).addClass("loading");

    if (currentPage === 0) {
      currentPage++;
    }
    let data = {
      action: "load_whats_new_posts",
      query: truePosts,
      page: currentPage,
      "post-per-load": postPerLoad,
      "term-id": termId,
    };

    $.ajax({
      url: ajaxUrl,
      data: data,
      type: "POST",
      success: function (data) {
        if (data) {
          loadMoreButton.attr("disabled", false).removeClass("loading");
          $(".col-md-8.offset-md-2.col-xl-6.offset-xl-3").append(data);
          currentPage++;
          loadMoreButton.data("current-page", currentPage);
          if (currentPage === maxPages) {
            loadMoreButton.css("display", "none").attr("disabled", true);
          } else {
            loadMoreButton.css("display", "flex").attr("disabled", false);
          }
        } else {
          loadMoreButton.css("display", "none").attr("disabled", true);
        }

        $(".card").each(function () {
          let $card = $(this);
          addReadMoreButton($card);
        });
      },
    });
  });
});
